import { createRouter, createWebHistory } from 'vue-router'
import { useLocale } from '@/composables/useLocale'

const HomePage = () => import('@/pages/HomePage.vue')
const ContactPage = () => import('@/pages/ContactPage.vue')
const NotFoundPage = () => import('@/pages/NotFoundPage.vue')

const routes = [
  { path: '/', component: HomePage, meta: { locale: 'en', page: 'home' } },
  { path: '/contact', component: ContactPage, meta: { locale: 'en', page: 'contact' } },
  { path: '/nl', component: HomePage, meta: { locale: 'nl', page: 'home' } },
  { path: '/nl/contact', component: ContactPage, meta: { locale: 'nl', page: 'contact' } },
  { path: '/:pathMatch(.*)*', component: NotFoundPage, meta: { page: 'notfound' } }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  const { setLocale } = useLocale()

  if (to.meta.locale) {
    setLocale(to.meta.locale)
  } else {
    const lang = to.path.startsWith('/nl') ? 'nl' : 'en'
    setLocale(lang)
  }
})

router.afterEach((to) => {
  const { t } = useLocale()
  const page = to.meta.page || 'home'
  const title = t(`meta.${page}.title`)
  const description = t(`meta.${page}.description`)
  const url = `https://www.orchestratio.com${to.path}`

  document.title = title

  const setMeta = (attr, key, value) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`)
    if (!el) {
      el = document.createElement('meta')
      el.setAttribute(attr, key)
      document.head.appendChild(el)
    }
    el.setAttribute('content', value)
  }

  const locale = to.path.startsWith('/nl') ? 'nl_NL' : 'en_GB'

  setMeta('name', 'description', description)
  setMeta('property', 'og:title', title)
  setMeta('property', 'og:description', description)
  setMeta('property', 'og:url', url)
  setMeta('property', 'og:locale', locale)
  setMeta('name', 'twitter:title', title)
  setMeta('name', 'twitter:description', description)

  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', url)
})

export default router
